import React from 'react'
import { FaUsers, FaHandshake } from 'react-icons/fa'
import { MdOutlineShield } from "react-icons/md";
import './DigiHealthLandingGovInd.css'

const DigiHealthLandingGovInd = () => {
  return (
    <section className="Digi-Health-Landing-Gov-ind-section-bg">
      <div className="Digi-Health-Landing-Gov-ind-section-container">
        <h2 className="Digi-Health-Landing-Gov-ind-section-title">
          Governance & Independence
        </h2>
        <p className="Digi-Health-Landing-Gov-ind-section-subtitle">
          Our commitment to neutrality and independence ensures balanced perspectives and evidence-based decision making.
        </p>
        <div className="Digi-Health-Landing-Gov-ind-section-cards">
          <div className="Digi-Health-Landing-Gov-ind-section-card">
            <div className="Digi-Health-Landing-Gov-ind-section-card-icon">
              <MdOutlineShield />
            </div>
            <div className="Digi-Health-Landing-Gov-ind-section-card-title">Non-Partisan</div>
            <div className="Digi-Health-Landing-Gov-ind-section-card-desc">
              Operating as an independent, not-for-profit entity free from political and commercial bias.
            </div>
          </div>
          <div className="Digi-Health-Landing-Gov-ind-section-card">
            <div className="Digi-Health-Landing-Gov-ind-section-card-icon">
              <FaUsers />
            </div>
            <div className="Digi-Health-Landing-Gov-ind-section-card-title">Multidisciplinary</div>
            <div className="Digi-Health-Landing-Gov-ind-section-card-desc">
              Governed by a diverse board representing various healthcare domains and expertise areas.
            </div>
          </div>
          <div className="Digi-Health-Landing-Gov-ind-section-card">
            <div className="Digi-Health-Landing-Gov-ind-section-card-icon">
              <FaHandshake />
            </div>
            <div className="Digi-Health-Landing-Gov-ind-section-card-title">Collaborative</div>
            <div className="Digi-Health-Landing-Gov-ind-section-card-desc">
              Supported through partnerships, research grants, and philanthropic contributions.
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default DigiHealthLandingGovInd
